import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions';
import axios from "../services";
import { sessionExpiredMsg } from "../constants/constants";

function* getContestList(action) {
    try {
        let response = yield axios.get('/users/contestsList-for-enroll')
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.getContestListSuccess(response.data.data));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA ENROLLCONTEST", error.message);
        yield put(actions.hideAppLoader());
    }
}

function* enrollContest(action) {
    try {
        let response = yield axios.post(`/users/contest/${encodeURIComponent(action.payload.contestName)}/enroll`, action.payload)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.modalOpen({ message: response.data.msg.replace("?",""), notifyType: 2, redirectURL: `/profile` }));
            yield put(actions.getEnrolledContests());
            yield put(actions.hideAppLoader());
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }

    } catch (error) {
        console.log("ERROR FROM SAGA ENROLLCONTEST", error.message);
    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_CONTEST_LIST, getContestList);
    yield takeEvery(actionTypes.ENROLL_CONTEST_REQUEST, enrollContest);
}